export const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_PARAMS':
      return { ...state, params: action.payload };
    case 'SET_PROGRAMS':
      return { ...state, programs: action.payload };
    case `SET_REPORTS`:
      return { ...state, report: { ...state?.report, ...action.payload} }
    case `UNSET_REPORTS`:
      return { ...state, report: null }
    case 'MENU_TOGGLE':
      return { ...state, isOpen: action.payload }
    default:
      return state;
  }
};
